/** `snippets/menu-drawer.liquid` — `<menu-drawer>`: mirrors body class state from header into open/aria/inert attributes. */

class MenuDrawer extends HTMLElement {
  #observer
  #key
  #className

  connectedCallback() {
    this.#key = this.dataset.menuDrawer
    if (!this.#key) return

    this.#className = `${this.#key}-menu-open`
    this.#sync()

    this.#observer = new MutationObserver(() => this.#sync())
    this.#observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
  }

  disconnectedCallback() {
    this.#observer?.disconnect()
    this.#observer = null
  }

  #sync() {
    const isOpen = document.body.classList.contains(this.#className)
    this.toggleAttribute('open', isOpen)
    this.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
    if (isOpen) {
      this.removeAttribute('inert')
    } else {
      this.setAttribute('inert', '')
    }
  }
}

if (!customElements.get('menu-drawer')) {
  customElements.define('menu-drawer', MenuDrawer)
}
